import { Recipient } from "../../graphql/types";
import { RecipientCard } from "./RecipientCard";

type RecipientsListProps = {
  recipients?: Recipient[] | null;
};

const RecipientsList = ({ recipients }: RecipientsListProps) => {
  return (
    <>
      {recipients?.map((recipient) => (
        <RecipientCard email={recipient.email} key={recipient.email} rules={recipient.rules} />
      ))}
    </>
  );
};

export { RecipientsList };
